import "./PICManagement.css";

import React, { useEffect, useState } from "react";

import IconButton from "../../IconButton/IconButton";
import TableComponent from "../../TableComponent/TableComponent";
import { DataTableComponent } from "../../../common/TableComponent/DataTableComponent";
import { useTranslation } from "react-i18next";

const ViewPICUserDetails = ({
    onCloseViewPICDetails,
    viewSlotData,
    slotDetails,
    data,
    onRevokeUser,
}) => {
    const { t, i18n } = useTranslation();
    const [tableData, setTableData] = useState([]);
    const [tableColumns, setTableColumns] = useState([]);

    useEffect(() => {
        let newTableColumns = [];
        let updatedData = [];
        newTableColumns.push({ name: t("roleName"), field: "roleName", selector: row => row.roleName });
        if (data.roleName === "PIC") {
            newTableColumns.push({
                name: t("entity"),
                field: "legalEntity",
                selector: row => row.legalEntity
            });
            updatedData.push({
                legalEntity: data?.organizationName,
                organizationId: data?.organizationId,
                roleId: data?.roleId,
                id: data?.id,
                roleName: data?.roleName,
                email: data?.email,
            });
        } else if (data.roleName === "PIC-BU") {
            newTableColumns.push({
                name: t("businessUnit"),
                field: "businessUnit",
                selector: row => row.businessUnit
            });
            updatedData.push({
                businessUnit: data?.organizationName,
                organizationId: data?.organizationId,
                roleId: data?.roleId,
                id: data?.id,
                roleName: data?.roleName,
                email: data?.email,
            });
        } else if (data.roleName === "PIC-SUBBU") {
            newTableColumns.push({
                name: t("subBU"),
                field: "subBusinessUnit",
                selector: row => row.subBusinessUnit
            });
            updatedData.push({
                subBusinessUnit: data?.organizationName,
                organizationId: data?.organizationId,
                roleId: data?.roleId,
                id: data?.id,
                roleName: data?.roleName,
                email: data?.email,
            });
        }

        setTableColumns(newTableColumns);
        setTableData(updatedData);
    }, [data, i18n.language]);

    return (
        <div className={["glbOuterWrapper", "slotMgmt"].join(" ")}>
            <div className="slotDetailsOuterDiv">
                <div style={{ display: "flex" }}>
                    <div>
                        <span className="slotDetailsText">{t("email")}:</span>
                        <span className="slotName">{data?.email}</span>
                    </div>
                    <div style={{ paddingLeft: "20px" }}>
                        <span className="slotDetailsText">{t("firstName")}:</span>
                        <span className="slotName">{data?.firstName}</span>
                    </div>
                    <div style={{ paddingLeft: "20px" }}>
                        <span className="slotDetailsText">{t("lastName")}:</span>
                        <span className="slotName">{data?.lastName}</span>
                    </div>
                </div>

                <div className="buttonOuterDiv">
                    <IconButton
                        text={t("close")}
                        onClick={onCloseViewPICDetails}
                        style={{
                            backgroundColor: "#F0F0F0",
                            color: "#454647",
                            border: "1px solid #B3B2B4",
                        }}
                    />
                </div>
            </div>

            <div className="viewTableOuterDiv">
                <DataTableComponent
                    columns={tableColumns}
                    data={tableData}
                    tableName="viewPIC"
                    noDataMessage={t("noDataFound") || "No Data Found"}
                    onRevokeUser={onRevokeUser}
                    pageCount={5}
                />
            </div>
        </div>
    );
};

export default ViewPICUserDetails;
